import React from "react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ as FAQ_IDS } from "@/constants/testIds";
import { useSiteContent } from "@/lib/siteContent";

export const FAQ = () => {
  const { content } = useSiteContent();
  const Q = content.faq_items || [];
  return (
    <section
      id="faq"
      data-testid={FAQ_IDS.root}
      className="py-24 lg:py-32 bg-[#F4EFE6]"
    >
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#CBA358] font-semibold">
          {content.faq_eyebrow}
        </div>
        <h2 className="font-display text-4xl lg:text-5xl mt-4 text-[#0A2342] leading-[1.05] text-balance">
          {content.faq_headline}
        </h2>

        <Accordion type="single" collapsible className="mt-12 w-full">
          {Q.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={FAQ_IDS.item(i)}
              className="border-b border-[#0A2342]/15 last:border-b-0"
            >
              <AccordionTrigger className="font-display text-xl text-[#0A2342] py-6 hover:no-underline text-left">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#5C636A] text-[16px] leading-relaxed pb-6 pr-8">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
